import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

interface TemporaryPasswordModalProps {
  password: string;
  onClose: () => void;
}

export const TemporaryPasswordModal: React.FC<TemporaryPasswordModalProps> = ({
  password,
  onClose,
}) => {
  const [copied, setCopied] = useState(false);

  const copyPassword = async () => {
    await navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-gray-500/75" onClick={onClose} />
        <div className="relative bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Temporary password (shown once)
          </h3>
          <div className="flex items-center gap-2 mb-4">
            <code className="flex-1 text-sm bg-gray-50 border rounded px-3 py-2 font-mono break-all">
              {password}
            </code>
            <button
              type="button"
              onClick={copyPassword}
              className="p-2 border rounded hover:bg-gray-50"
            >
              {copied ? (
                <Check className="w-4 h-4" />
              ) : (
                <Copy className="w-4 h-4" />
              )}
            </button>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};
